import React from 'react';
import { Helmet } from 'react-helmet-async';
import MetaHero from '../components/MetaHero';
import MetaGenerator from '../components/MetaGenerator';
import MetaFeatures from '../components/MetaFeatures';
import MetaHowItWorks from '../components/MetaHowItWorks';
import MetaTestimonials from '../components/MetaTestimonials';
import MetaGuide from '../components/MetaGuide';
import MetaSEOContent from '../components/MetaSEOContent';
import MetaFAQ from '../components/MetaFAQ';
import MetaCallToAction from '../components/MetaCallToAction';

export default function MetaPage() {
  return (
    <>
      <Helmet>
        <title>Meta Title Generator | Create SEO-Optimized Meta Titles</title>
      </Helmet>
      <MetaHero />
      <MetaGenerator />
      <MetaFeatures />
      <MetaHowItWorks />
      <MetaTestimonials />
      <MetaGuide />
      <MetaSEOContent />
      <MetaFAQ />
      <MetaCallToAction />
    </>
  );
}